const ALLOWED_TAGS = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p'];

/**
 * Úroveň nadpisu se ve Strapi volí nezávisle na jeho vzhledu – komponenta určuje,
 * jak nadpis vypadá (heading-1…heading-6), pole `htmlTag` jakou má sémantickou úroveň.
 * Když editor `htmlTag` nevyplní, použije se výchozí tag komponenty (H4 → <h4> atd.).
 */
export const resolveHeadingTag = (htmlTag, fallback) => (ALLOWED_TAGS.includes(htmlTag) ? htmlTag : fallback);
